import { CustomData } from 'owa-analytics-actions';
import { errorThatWillCauseAlert, TraceErrorObject } from 'owa-trace';
import { logUsage } from 'owa-analytics';

const LOG_ERROR_PREFIX = '[WebPush] ';

const enum WebpushMetric {
    FAILURE = 'WebPush_Failure',
}

/**
 * To be used when an error breaks business logic, but not user critical workflows in Push Notifications.
 * This is for any additional logs that would help debug issue faster, if any.
 */
const logFailure = (
    failureMessage: string,
    error?: TraceErrorObject,
    customData: CustomData = {}
): void => {
    const preparedCustomData = {
        errorName: failureMessage,
        ...(error ? { errorMsg: error.message, errorStack: error.stack } : {}),
        ...addCommonProperties(),
        ...customData,
    };

    logUsage(WebpushMetric.FAILURE, preparedCustomData, {
        isCore: true,
    });
};

/**
 * To be used when an error breaks user's workflow in Push Notifications.
 * This is for the core or critical workflows of user.
 */
const logErrorToCauseAlert = (errorMsg: string, error?: TraceErrorObject): void => {
    errorThatWillCauseAlert(LOG_ERROR_PREFIX + errorMsg, error);
};

const addCommonProperties = (): CustomData => ({
    isBackground: window.document.visibilityState !== 'visible',
});

export { logFailure, logErrorToCauseAlert };
